import { Bullets, ListTextarea } from './listUtils.tsx';
import type { EditProps, ViewProps } from './types.ts';

const QUADRANTS = [
  { key: 'strengths', label: 'Strengths', accent: 'border-l-green-500' },
  { key: 'weaknesses', label: 'Weaknesses', accent: 'border-l-red-400' },
  { key: 'opportunities', label: 'Opportunities', accent: 'border-l-blue-500' },
  { key: 'threats', label: 'Threats', accent: 'border-l-amber-500' },
] as const;

export function SwotView({ content }: ViewProps<'swot'>) {
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      {QUADRANTS.map((q) => (
        <div
          key={q.key}
          className={`break-inside-avoid rounded-lg border border-l-4 border-gray-200 p-3 ${q.accent}`}
        >
          <h4 className="mb-1.5 text-xs font-semibold tracking-wide text-gray-500 uppercase">
            {q.label}
          </h4>
          <Bullets items={content[q.key]} />
        </div>
      ))}
    </div>
  );
}

export function SwotEdit({ content, onChange }: EditProps<'swot'>) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {QUADRANTS.map((q) => (
        <ListTextarea
          key={q.key}
          label={q.label}
          values={content[q.key]}
          onChange={(values) => onChange({ ...content, [q.key]: values })}
        />
      ))}
    </div>
  );
}
